(() => {
  document.documentElement.classList.add('pb-has-js');
  function filterSupplies(value) {
    document.querySelectorAll('[data-pb-explorer]').forEach(explorer => {
      const buttons = [...explorer.querySelectorAll('[data-pb-filter]')];
      if (!buttons.some(button => button.dataset.pbFilter === value)) return;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pbFilter === value)));
      let visible = 0;
      explorer.querySelectorAll('[data-pb-category]').forEach(card => {
        card.hidden = value !== 'all' && card.dataset.pbCategory !== value;
        if (!card.hidden) visible++;
      });
      const status = explorer.querySelector('[data-pb-filter-status]');
      if (status) status.textContent = status.dataset.pbStatusPattern.replace('__COUNT__', String(visible));
    });
  }
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-pb-filter]');
    if (filter) filterSupplies(filter.dataset.pbFilter);
    const link = event.target.closest('[data-pb-filter-link]');
    if (link) {
      const explorer = document.querySelector('[data-pb-explorer]');
      if (explorer) filterSupplies(link.dataset.pbFilterLink);
      else sessionStorage.setItem('popbeads-pending-filter', link.dataset.pbFilterLink);
    }
    const menuLink = event.target.closest('.pb-mobile-menu nav a');
    if (menuLink) menuLink.closest('details').open = false;
    const opener = event.target.closest('[data-pb-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.pbOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
    }
    const closer = event.target.closest('[data-pb-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.pb-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  const pending = sessionStorage.getItem('popbeads-pending-filter');
  if (pending && document.querySelector('[data-pb-explorer]')) {
    filterSupplies(pending);
    sessionStorage.removeItem('popbeads-pending-filter');
  }
})();
